import Model from 'core/model/Model';
import { computed } from 'mobx';

class KentikAgentClusterModel extends Model {
  get urlRoot() {
    return '/api/ui/kentik-agent/clusters';
  }

  @computed
  get name() {
    return this.get('cluster.displayName');
  }
}

export default KentikAgentClusterModel;
